module.exports = __webpack_public_path__ + "img/jqf.1c94e0b6.png";